import React from 'react';
import config from 'config/config';

// https://www.timeanddate.com/clocks/freecountdown.html
const CountDownClock: React.FC<{ disabled?: boolean }> = ({ disabled }: { disabled?: boolean }) => {
    if (disabled) {
        return null;
    }

    return (
        <iframe
            title="CountDown Clock"
            style={{ width: 283, height: 62, margin: 20, pointerEvents: 'none', border: 'none' }}
            src={`https://free.timeanddate.com/countdown/i7gnkd1c/n1393/cf12/cm0/cu5/ct0/cs0/ca0/co0/cr0/ss0/cacef6422/cpcff3422/pct/tcfff/fs100/szw576/szh243/iso${config.COUNTDOWNCLOCK}T17:00:00/pa5`}
        />
    );
};

export default CountDownClock;
